import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';
import { IS_WEB } from '@/shared/constants/utility';

function readWebPrefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Cross-platform `prefers-reduced-motion` / reduce-motion accessibility setting.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() =>
    IS_WEB ? readWebPrefersReducedMotion() : false,
  );

  useEffect(() => {
    if (IS_WEB) {
      if (typeof window === 'undefined' || !window.matchMedia) {
        return;
      }
      const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sync = () => {
        setPrefersReducedMotion(mq.matches);
      };
      sync();
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', sync);
        return () => {
          mq.removeEventListener('change', sync);
        };
      }
      mq.addListener(sync);
      return () => {
        mq.removeListener(sync);
      };
    }

    void AccessibilityInfo.isReduceMotionEnabled()
      .then(setPrefersReducedMotion)
      .catch((error: unknown) => {
        console.error(
          'usePrefersReducedMotion: failed to read reduce motion preference',
          error,
        );
        setPrefersReducedMotion(false);
      });
    const subscription = AccessibilityInfo.addEventListener(
      'reduceMotionChanged',
      setPrefersReducedMotion,
    );
    return () => {
      subscription.remove();
    };
  }, []);

  return prefersReducedMotion;
}
